import React from "react";
import { useState } from "react";

const WrapperDoubleClickable = ({ onDoubleClick, children }) => {
  const TIMEOUT_MILLISECONDS = 500;

  const [lastClicked, setLastClicked] = useState<number | null>(null);

  const onClick = () => {
    const currentTime = new Date().getTime();
    if (lastClicked && currentTime - lastClicked < TIMEOUT_MILLISECONDS) {
      onDoubleClick();
    }
    setLastClicked(currentTime);
  };

  return <div onClick={onClick}>{children}</div>;
};

export default WrapperDoubleClickable;
